export default __webpack_public_path__ + "static/media/lockbox.85e8607b.svg";